export default __webpack_public_path__ + "static/media/bannersweb_RW_coche_moto_1000_330x330(2).baf8c570.jpg";